module.exports = __webpack_public_path__ + "img/9788984078017.cbc58cb3.jpg";